import { useSelector, useDispatch } from 'react-redux'
import Conversation from '../../messenger/Conversation.js'

export default function StoryConversation ({ slice }) {
  const { actions, selectors } = slice
  const dispatch = useDispatch()
  const conversation = useSelector(selectors.selectConversation)
  const isShowConversation = useSelector(selectors.selectIsShowConversation)

  return (
    isShowConversation && <Conversation
      isOpen={isShowConversation}
      onClose={() => dispatch(actions.showMarker())}
      messages={conversation && conversation.messages}
      from={conversation && conversation.from}
                          />
  )
}
